export const TICKET_COPY_COLUMNS = ['ticket_number','title','description','customer','ticket_details',
  'ticket_categories','ticket_subcategories','fit_score','fit_reasoning','theo_link'];

/** Decode the server's CSV without treating quoted line breaks as ticket boundaries. */
function csvRows(csv: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [], cell = '', quoted = false;
  for (let index = 0; index < csv.length; index++) {
    const char = csv[index];
    if (quoted) {
      if (char !== '"') cell += char;
      else if (csv[index + 1] === '"') { cell += '"'; index++; }
      else quoted = false;
    } else if (char === '"' && !cell) quoted = true;
    else if (char === ',') { row.push(cell); cell = ''; }
    else if (char === '\r' || char === '\n') {
      row.push(cell); rows.push(row); row = []; cell = '';
      if (char === '\r' && csv[index + 1] === '\n') index++;
    } else cell += char;
  }
  if (quoted) throw new Error('Unable to read ticket copy. Please try again.');
  if (cell || row.length) { row.push(cell); rows.push(row); }
  if (!rows.length || rows.some(values => values.length !== rows[0].length)) {
    throw new Error('Unable to read ticket copy. Please try again.');
  }
  return rows;
}

const escapeHtml = (text: string) => text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
const numericColumns = new Set(['fit_score']);

/** Rich table for spreadsheet paste; flat TSV fallback keeps each ticket on one row. */
function spreadsheetRows(headers: string[], rows: string[][]): { plainText: string; html: string } {
  const plainText = rows.map(row => row.map(cell => {
    let text = cell.replace(/\r\n|[\r\n\u2028\u2029]/g, '\\n').replace(/\t/g, '\\t');
    // Customer text is data, including text that resembles a spreadsheet formula.
    if (/^\s*[=+@-]/.test(text)) text = "'" + text;
    return text.includes('"') ? `"${text.replace(/"/g, '""')}"` : text;
  }).join('\t')).join('\r\n') + (rows.length ? '\r\n' : '');
  const html = '<html><head><meta charset="utf-8"></head><body><table><tbody>' + rows.map(row => '<tr>' + row.map((cell, column) => {
    const numeric = numericColumns.has(headers[column]) && cell !== '' && Number.isFinite(Number(cell));
    return `<td style="white-space:pre-wrap;mso-number-format:${numeric ? 'General' : "'@'"}">` + escapeHtml(cell)
      .replace(/\r\n|[\r\n]/g, '<br style="mso-data-placement:same-cell">') + '</td>';
  }).join('') + '</tr>').join('') + '</tbody></table></body></html>';
  return { plainText, html };
}

export function ticketSpreadsheetClipboard(csv: string): { plainText: string; html: string } {
  const [headers, ...rows] = csvRows(csv);
  return spreadsheetRows(headers, rows);
}

export function ticketSpreadsheetHeaders(): { plainText: string; html: string } {
  return spreadsheetRows(TICKET_COPY_COLUMNS, [TICKET_COPY_COLUMNS]);
}
